import React,{useState,useEffect} from 'react';
import { PATHS } from '../../../../common/constants';
import { useHistory } from 'react-router-dom';
import "./HomeOwnerOnboardingDashboard.scss";
import "./Media.scss";
import { onRequestPhoneCall } from '../../../../helpers/validationHelper';
import { selectAuthenticatedUser } from '../../../../store/selectors/auth';
import FeedBack from  '../../../../components/FeedBack';
import { connect } from "react-redux";

const KeycontactsList = ({
    details,
    videoSummary,user
}) => {
    const history = useHistory();
    const [feedBackReportPopup,setFeedBackReportPopup]=useState(false);
    var dashboardURL=window.location.href;
    //Modified By: Anjali
    //Modified On: 13-11-2023
    //Jira-Id: https://bosframework.atlassian.net/browse/JUN-3777
    //Reason: page rendering multiple times because of this code used in two components (suits , keycontactsList)

  //   useEffect(() => {
  //     if(user && user.roles && user.roles.length > 0 && (user.roles[0].role.name === "Home Owner") && dashboardURL.search('app/dashboard')>-1){
  //         let isfeedBackReportPopup = localStorage.getItem('IsHomerNavigatFromFeedBackTemplate')
  //         if(isfeedBackReportPopup!==undefined &&  isfeedBackReportPopup!==null && isfeedBackReportPopup!=''){
  //           setFeedBackReportPopup(true);
  //         }
  //      }
  //  });
    return (
    <div
      className="contactInformation"
      style={{
        width:
          !details.video &&
          !(videoSummary && videoSummary.trim()) &&
          "100%",
      }}
    >
      {
      feedBackReportPopup && <FeedBack/>
      }
      <div
        className="contactIn"
        style={{
          height:
            details.video &&
            !(videoSummary && videoSummary.trim()) &&
            "330px",
        }}
      >
        <h3>
          Contact Information{" "}
          <span
            onClick={() =>
              history.push(PATHS.KEY_CONTACTS_LIST)
            }
            className="view_button"
          >
            View complete list
          </span>
        </h3>
        {details.suiteOnboardingKeyInformation.length > 0 ? ( 
          details.suiteOnboardingKeyInformation.map((info) => {
            return (
              <div className="contactlist">
                <h4>{info.name}</h4>
                <p>
        {info.department == "" ||
        info.department == null ? null : (
          <span className="mr-10">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 16.15C12.7249 16.15 16.15 12.7249 16.15 8.5C16.15 4.27507 12.7249 0.85 8.5 0.85C4.27507 0.85 0.85 4.27507 0.85 8.5C0.85 12.7249 4.27507 16.15 8.5 16.15ZM8.5 17C13.1946 17 17 13.1946 17 8.5C17 3.80545 13.1946 0 8.5 0C3.80545 0 0 3.80545 0 8.5C0 13.1946 3.80545 17 8.5 17Z"
                  fill="black"
                />
                <path
                  d="M3.40039 13.4428C3.40039 13.0038 3.72849 12.6328 4.16539 12.5843C7.44427 12.2214 9.57139 12.2541 12.843 12.5924C13.0064 12.6096 13.1613 12.6739 13.2887 12.7777C13.4161 12.8814 13.5105 13.0199 13.5604 13.1764C13.6104 13.3329 13.6137 13.5006 13.5699 13.6589C13.5261 13.8172 13.4372 13.9594 13.3139 14.068C9.45282 17.4336 7.24622 17.3873 3.67239 14.0714C3.49814 13.9099 3.40039 13.6804 3.40039 13.4433V13.4428Z"
                  fill="black"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.7985 13.0148C9.55276 12.679 7.45624 12.6476 4.21094 13.0067C3.99249 13.0309 3.82461 13.2175 3.82461 13.4432C3.82461 13.5647 3.87519 13.6799 3.96061 13.7598C5.73201 15.4029 7.07416 16.1453 8.38614 16.15C9.70279 16.1547 11.1172 15.4182 13.0339 13.7479C13.0948 13.6937 13.1387 13.623 13.1601 13.5443C13.1816 13.4657 13.1797 13.3825 13.1548 13.3049C13.1298 13.2273 13.0829 13.1586 13.0196 13.1072C12.9564 13.0557 12.8796 13.0238 12.7985 13.0152V13.0148ZM4.11786 12.1618C7.43116 11.795 9.58931 11.8282 12.8865 12.1695C13.1322 12.1951 13.3652 12.2919 13.5568 12.4479C13.7485 12.6039 13.8905 12.8124 13.9654 13.0479C14.0404 13.2834 14.045 13.5356 13.9789 13.7737C13.9127 14.0118 13.7785 14.2254 13.5928 14.3884C11.6484 16.0833 10.0292 17.0064 8.38359 17C6.73331 16.9941 5.18546 16.0552 3.38304 14.3829C3.25399 14.2627 3.15111 14.1171 3.08084 13.9554C3.01056 13.7936 2.9744 13.6191 2.97461 13.4428C2.97399 13.1259 3.0903 12.8199 3.30125 12.5835C3.5122 12.3471 3.80297 12.1968 4.11786 12.1614V12.1618Z"
                  fill="black"
                />
                <path
                  d="M11.8996 6.7999C11.8996 7.70164 11.5414 8.56644 10.9038 9.20407C10.2661 9.84169 9.40135 10.1999 8.49961 10.1999C7.59787 10.1999 6.73307 9.84169 6.09545 9.20407C5.45782 8.56644 5.09961 7.70164 5.09961 6.7999C5.09961 5.89817 5.45782 5.03336 6.09545 4.39574C6.73307 3.75812 7.59787 3.3999 8.49961 3.3999C9.40135 3.3999 10.2661 3.75812 10.9038 4.39574C11.5414 5.03336 11.8996 5.89817 11.8996 6.7999Z"
                  fill="black"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.49961 9.3499C9.17591 9.3499 9.82451 9.08124 10.3027 8.60302C10.781 8.12481 11.0496 7.4762 11.0496 6.7999C11.0496 6.1236 10.781 5.475 10.3027 4.99678C9.82451 4.51856 9.17591 4.2499 8.49961 4.2499C7.82331 4.2499 7.1747 4.51856 6.69649 4.99678C6.21827 5.475 5.94961 6.1236 5.94961 6.7999C5.94961 7.4762 6.21827 8.12481 6.69649 8.60302C7.1747 9.08124 7.82331 9.3499 8.49961 9.3499ZM8.49961 10.1999C9.40135 10.1999 10.2661 9.84169 10.9038 9.20407C11.5414 8.56644 11.8996 7.70164 11.8996 6.7999C11.8996 5.89817 11.5414 5.03336 10.9038 4.39574C10.2661 3.75812 9.40135 3.3999 8.49961 3.3999C7.59787 3.3999 6.73307 3.75812 6.09545 4.39574C5.45782 5.03336 5.09961 5.89817 5.09961 6.7999C5.09961 7.70164 5.45782 8.56644 6.09545 9.20407C6.73307 9.84169 7.59787 10.1999 8.49961 10.1999Z"
                  fill="black"
                />
              </g>
            </svg>
            {info.department}{" "}
          </span>
        )}{" "}
        {
          info.email?(
            <span>
          <svg
            width="17"
            height="14"
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.5"
              d="M15.3 12.25H13.6V4.59375L8.5 7.875L3.4 4.59375V12.25H1.7V1.75H2.72L8.5 5.46875L14.28 1.75H15.3V12.25ZM15.3 0H1.7C0.7565 0 0 0.77875 0 1.75V12.25C0 12.7141 0.179107 13.1592 0.497918 13.4874C0.81673 13.8156 1.24913 14 1.7 14H15.3C15.7509 14 16.1833 13.8156 16.5021 13.4874C16.8209 13.1592 17 12.7141 17 12.25V1.75C17 1.28587 16.8209 0.840752 16.5021 0.512563C16.1833 0.184374 15.7509 0 15.3 0Z"
              fill="black"
            />
          </svg>
          {info.email}{" "}
        </span>
          ):(null)
        }
                </p>
                {info.phone == "" || info.phone == null ? null : (
        <p>
          <span>
            <svg
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="14"
              viewBox="0 0 512.000000 512.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
              >
                <path
                  d="M1337 5109 c-129 -31 -231 -141 -257 -278 -14 -74 -14 -4468 0 -4542
22 -113 95 -209 198 -257 l57 -27 1225 0 1225 0 57 27 c103 48 176 144 198
257 14 74 14 4468 0 4542 -22 113 -95 209 -198 257 l-57 27 -1205 2 c-683 0
-1221 -3 -1243 -8z m1623 -259 c8 -14 8 -26 0 -40 -10 -19 -21 -20 -400 -20
-379 0 -390 1 -400 20 -8 14 -8 26 0 40 10 19 21 20 400 20 379 0 390 -1 400
-20z m850 -2245 l0 -1965 -1250 0 -1250 0 0 1965 0 1965 1250 0 1250 0 0
-1965z m-1193 -2096 c34 -13 80 -55 99 -91 32 -61 11 -154 -45 -201 -114 -96
-281 -17 -281 133 0 114 122 199 227 159z"
                />
              </g>
            </svg>
            {onRequestPhoneCall(info.phone)}{" "}
          </span>
        </p>
                )}
              </div>
            );
          })
        ) : (
          <div>No contact information found.</div>
        )}
      </div>
    </div>
    )
}
const mapStateToProps = (state) => {
  return {
     user:selectAuthenticatedUser(state)
  };
};
export default connect(mapStateToProps) (KeycontactsList);